export const data7_1_2 = [{
    name: 'Rooms 客房',
    name_code: "Rooms",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Administration& General 行政办 、财务、保安',
    name_code: "Administration_General",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Human Resources 人力资源部',
    name_code: "Human_Resources",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Sales & Marketing 市场销售部',
    name_code: "Sales_Marketing",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Property Operation & Maintenance 工程部',
    name_code: "Property_Operation_Maintenance",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Other Operated Departments 其它运营部门',
    name_code: "Other_Operated_Departments",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}, {
    name: 'Total 合计',
    name_code: "Payroll_Total",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
}];


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-5/data.js